// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_dynamic-form_containers_dynamic-form_dynamic-form_component_ts-src_app_dynami-5a7bf7":"d2e5924b6e0279a1","src_app_competitions_competitions_module_ts":"0fa27b44874200f2","src_app_courses_courses_module_ts":"a57f2a267940f7fd","src_app_users_users_module_ts":"afcd61372bd334c8"}[chunkId] + ".js";
};